export default __webpack_public_path__ + "static/media/upgrade.cecbced0.png";